import {
    SET_ATTACHMENT,
    UPLOAD_ATTACHMENTS,
    REMOVE_ATTACHMENT,
    REMOVE_ALL_ATTACHMENTS
} from "./UploadAttachmentsType"

const setAttachments = (attachmentList: any) => ({
    type: SET_ATTACHMENT,
    attachmentList,
});

const uploadAttachments = (attachmentList: any) => ({
    type: UPLOAD_ATTACHMENTS,
    attachmentList,
});

const removeAttachment = (attachmentList: any) => {
    return {
        type: REMOVE_ATTACHMENT,
        attachmentList,
    };
};

const removeAllAttachments = () => ({
    type: REMOVE_ALL_ATTACHMENTS,
});

export {
    setAttachments,
    uploadAttachments,
    removeAttachment,
    removeAllAttachments
}
